module.exports = __webpack_public_path__ + "4e97e2ce0421c4606b95a95dac1e81b7-pipelines_circle_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/ugiPipelines/assets/pipelines_circle_2x.png
// module id = 759
// module chunks = 0